import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  user: null,
  isLoggedIn: false,
  isError: false,
  isSuccess: false,
  isLoading: false,
  twoFactor: false,
  message: "",
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    reset(state) {
      state.isError = false;
      state.isSuccess = false;
      state.isLoading = false;
      state.message = "";
    },
    setProfile(state, action) {
      state.user = action.payload;
      state.isLoggedIn = true;
      state.isSuccess = true;
    },

    clearUser(state) {
      state.user = null;
      state.isLoggedIn = false;
    },
  },
});

export const { reset, setProfile, clearUser } = authSlice.actions;
export const authReducer = authSlice.reducer;
export const selectUser = (state) => state.auth.user;
export const selectIsLoggedIn = (state) => state.auth.isLoggedIn;
export const selectIsLoading = (state) => state.auth.isLoading;
export const selectSuccess = (state) => state.auth.isSuccess;
